export const reducer = (state, { type, payload }) => {
  switch (type) {
    case "removeActiveFiters":
      return {
        ...state,
        activeFilters: [],
        activeFilterGroups: []
      };
    case "addFilterToActiveFilters":
      return {
        ...state,
        activeFilters: [...state.activeFilters, payload]
      };
    case "removeFilterFromActiveFilters":
      return {
        ...state,
        activeFilters: state.activeFilters.filter(filter => filter !== payload)
      };
    case "addFilterGroupToActiveFilters":
      return {
        ...state,
        activeFilterGroups: [...state.activeFilterGroups, payload]
      };
    case "removeFilterGroupFromActiveFilters":
      return {
        ...state,
        activeFilterGroups: state.activeFilterGroups.filter(
          group => group !== payload
        )
      };
    case "addActiveSubtractions":
      if (state.activeSubtractions.indexOf(payload) !== -1) return state;
      return {
        ...state,
        activeSubtractions: [...state.activeSubtractions, payload]
      };
    case "removeActiveSubtractions":
      return {
        ...state,
        activeSubtractions: state.activeSubtractions.filter(
          subtraction => subtraction !== payload
        )
      };
    case "updateView":
      return {
        ...state,
        view: payload
      };
    case "updateYear":
      return {
        ...state,
        year: payload
      };
    case "updateUid":
      return {
        ...state,
        uid: payload
      };
    case "removeDate":
      return {
        ...state,
        date: false
      };
    default:
      return state;
  }
};

export const getInitialState = ({ query, userCalendar, calendar, moment }) => {
  return {
    date: query.date ? query.date : false,
    year: calendar === null ? moment().format("YYYY") : calendar.dataset.year,
    uid:
      calendar === null
        ? null
        : calendar.dataset.uid == "null"
        ? null
        : calendar.dataset.uid,
    userCal: calendar === null?null:JSON.parse(calendar.dataset.userCalendar),
    view: userCalendar ? userCalendar.active_view : query.view,
    activeFilterGroups: userCalendar
      ? userCalendar.active_filters.groups === null
        ? []
        : userCalendar.active_filters.groups
      : query.groups,
    activeFilters: userCalendar
      ? userCalendar.active_filters.filters === null
        ? []
        : userCalendar.active_filters.filters
      : query.filters,
    activeSubtractions: []
  };
};
